import { EndorsementKey, type EndorsementConfig } from '../../types';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.HiredAutoAndNonOwnedAuto,
  label: 'Hired and Non-Owned Auto Coverage',
  description: 'Add this coverage if your business uses personal autos for work-related reasons.',
  recommended: true,
};
